import React from "react";
import PropTypes from "prop-types";
import "../../css/navBar.css";

const DropDownVacante = ({ acciones }) => {
  if (!acciones.length) return null;

  return (
    <div className="dropdown text-end d-flex d-md-none justify-content-end">
      <button
        className="px-4 py-2 d-block bgArcopime text-decoration-none dropdown-toggle border-0"
        type="button"
        id="dropdownVacanteActions"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ borderRadius: "8px" }}
      >
        Acciones
      </button>
      <ul style={{ borderRadius: "8px", boxShadow: "0 7px 7px rgba(0, 0, 0, 0.1)" }} className="dropdown-menu dropdown-menu-end text-small p-1" aria-labelledby="dropdownVacanteActions">
        {acciones.map(accion => (
          <li className="dropdown-item-li" key={accion.key}>
            <button className="dropdown-item py-2" onClick={accion.onClick}>
              {accion.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

DropDownVacante.propTypes = {
  acciones: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

DropDownVacante.defaultProps = {
  acciones: [],
};

export default DropDownVacante;
